import React from "react";
import "@/styles/connie.css";

/** Connie's face — the Connexis mark, glowing. state: idle | thinking | speaking. */
export const ConnieMark = ({ size = 44, state = "idle", orbit, testId = "connie-mark", className = "" }) => (
  <span className={`connie-mark${state !== "idle" ? ` is-${state}` : ""} ${className}`}
        style={{ "--s": `${size}px` }} data-testid={testId} aria-hidden="true">
    <span className="cm-halo" />
    <span className="cm-ring" />
    <span className="cm-core" />
    <svg className="cm-logo" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
      <path d="M4 7h7" strokeLinecap="round" />
      <path d="M4 12h12" strokeLinecap="round" />
      <path d="M4 17h7" strokeLinecap="round" />
      <circle cx="18" cy="7" r="2.3" stroke="none" />
      <circle cx="18" cy="17" r="2.3" stroke="none" />
    </svg>
    {(orbit ?? size >= 80) && (
      <>
        <span className="cm-orbit"><i /><i /><i /></span>
        <span className="cm-orbit r2"><i /><i /></span>
      </>
    )}
  </span>
);

export default ConnieMark;
